import { isDev } from '@utils/Environment';
import { worker } from './browser';
import { handlers } from './handlers';

if (isDev() && handlers.length > 0) {
  worker.start({ onUnhandledRequest: 'bypass' });
}
